/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { FormHelperText, Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const SelectBox = (props) => {
  const {
    name, value, label, required, placeholder, options, variant = 'outlined', error = null, onChange, open, onOpen, onClose, id , ...others
  } = props;
  const [state, setState] = React.useState('');

  useEffect(() => {
    setState(value);
  }, [value]);

  const handleChange = (event) => {
    setState(event.target.value);
    onChange(event);
  };
  return (
    <FormControl
      variant={variant}
      className="formControl"
      {...(error && { error: 'true', helpertext: error })}
    >
      {label &&
        <Typography
          component="p"
          className={required ? 'inputLabel required' : 'inputLabel'}
        >{label}
        </Typography>
      }
      <Select
        open={open}
        onClose={onClose}
        onOpen={onOpen}
        name={name}
        value={state}
        onChange={handleChange}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left"
          },
          getContentAnchorEl: null,
        }}
        sx={{
          '& .MuiSelect-select': {
            padding: '8px 14px',
          },
        '&.Mui-disabled .MuiSelect-icon': {
                  color: '#c2185b', // your default color
                },
        }}

        {...others}
      >
        {placeholder && <MenuItem value="" >{placeholder}</MenuItem>}
        {
          options && options.map(item => (
            <MenuItem key={item?.value} value={item?.value} disabled={item?.disabled} id={id}>{item?.title}</MenuItem>
          ))
        }
      </Select>
      <FormHelperText>{error && error}</FormHelperText>
    </FormControl>
  );
};

export default SelectBox;
